import React from 'react';
import { Typography } from '@material-ui/core';
import { cellTypes, headerTypes } from '@bento-core/table';
import DocumentDownloadView from '../../../../components/DocumentDownload/DocumentDownloadView';
import { removeSquareBracketsFromString } from '../../../../utils/utils';
import { applySubstitutions } from '../../utils';

export const CustomCellView = (props) => {
  const {
    downloadDocument, documentDownloadProps, substitutionRules,
    displayEmpty, dataField, removeSquareBrackets
  } = props;
  if (downloadDocument) {
    return (
      <DocumentDownloadView
        // fileSize={props.file_size}
        fileSize={props[documentDownloadProps.fileSizeColumn]}

        caseId={props[documentDownloadProps.caseIdColumn]}
        fileFormat={props[documentDownloadProps.fileFormatColumn]}
        fileLocation={props[documentDownloadProps.fileLocationColumn]}
        studyAccession={props[documentDownloadProps.studyAccessionColumn] || props.study_accession}
        {...documentDownloadProps}
        {...props}
        requiredACLs={props[dataField]}
        fileName={props[documentDownloadProps.fileName]}
      />
    );
  } else if (removeSquareBrackets) { 
    return (
      // If removeSquareBrackets flag is true, remove square brackets
      <Typography>
        {props[dataField] ? removeSquareBracketsFromString(props[dataField]) : ""}
      </Typography>
    );
  } else if (substitutionRules) { 
    return (
      // If removeSquareBrackets flag is true, remove square brackets
      <Typography>
        {props[dataField] ? applySubstitutions(props[dataField], substitutionRules) : "" }
      </Typography>
    );
  } else if (typeof displayEmpty === "boolean") {
    return (<Typography>{displayEmpty || props[dataField] ? props[dataField] : ""}</Typography>);
  }

  // other custom elem
  return (<></>);
};

export const CustomHeaderCellView = (props) => {
 
    return <> {props.header}</>
}


/**
* set column configuration
* @param {*} columns
* @returns config columns
*/
export const configColumn = (columns) => {
  /**
  * display columns as configuration
  * set custom cell render for column
  */
  const displayColumns = columns.filter((col) => col.display || col.hiddenByDefault);
  const displayCustomView = [...displayColumns].map((column) => {
    if (column.cellType === cellTypes.CUSTOM_ELEM) {
      return {
        ...column,
        customCellRender: (props) => <CustomCellView {...props} />,
      };
    }
    return column;
  });

  /**
  * custom header view configuration
  */
  const displayCustomHeader = [...displayCustomView].map((column) => {
    if (column.headerType === headerTypes.CUSTOM_ELEM) {
      return {
        ...column,
        customColHeaderRender: (props) => <CustomHeaderCellView {...props} />,
      };
    }
    return column;
  });
  return displayCustomHeader;
};
